import { Link } from "react-router";
import { Id, Reserved, WishlistItem } from "../../../data/types";
import WishImage from "./WishImage";

interface WishlistItemViewProps {
  wishlistId: Id;
  item: WishlistItem;
  userId?: Id;
  isMyWishlist: boolean;
  reservedRec?: Reserved;
}

export default function WishlistItemView({
  wishlistId,
  item,
  userId,
  isMyWishlist,
  reservedRec,
}: WishlistItemViewProps) {
  return (
    <>
      <Link to={`/wishlist/${wishlistId}/${item.id}`} viewTransition>
        <div className="wish-text-primary relative flex w-64 flex-col gap-2 hover:text-link-hover">
          <WishImage imageLink={item.imageLink || ""} />
          {!isMyWishlist && reservedRec && (
            <div className="z-5 wish-bg-reserved wish-text-white absolute h-64 w-64 flex-col content-center gap-3 rounded-3xl p-3 text-center">
              <div className="H1">✨</div>
              <div className="H4">
                {userId === reservedRec.userId
                  ? "Reserved by you"
                  : "Reserved by someone else"}
              </div>
            </div>
          )}
          <div>
            <div className="H6 overflow-hidden truncate">{item.name}</div>
            <div className="Body">
              {item.price} {item.price && item.currency}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
}
